import { css } from 'styled-components'

function sortedKeys(theme, obj) {
  const keys = Object.keys(obj || {})
  const order = Object.entries(theme.breakpoints || {}).sort((a, b) => a[1] - b[1]).map(([k]) => k)
  return order.filter((k) => keys.includes(k))
}

export function responsive(prop, val, theme, map) {
  if (val == null) return css``
  if (typeof val !== 'object') return css`${prop}: ${map ? map(val) : val};`
  const base = val.base != null ? val.base : undefined
  const keys = sortedKeys(theme, val)
  const first = keys[0]
  const initial = base != null ? base : (first != null ? val[first] : undefined)
  let out = ''
  if (initial != null) out += `${prop}: ${map ? map(initial) : initial};`
  keys.forEach((k) => {
    if (k === first && base == null) return
    const px = theme.breakpoints[k]
    out += `@media (min-width: ${px}px){ ${prop}: ${map ? map(val[k]) : val[k]}; }`
  })
  return css`${out}`
}
